import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { Text } from '../../cdl/Text/Text';
import { theme } from '../ui/theme';

// Component definition until the CDL component is implemented

const basicHeaderWithLineStyles = css`
    padding-bottom: 12px;
    border-bottom: 1px solid ${theme.colors.border.muted};
`;

const AdvancedHeaderWithLine = styled.div`
    display: grid;
    grid-template-columns: auto max-content;
    grid-template-rows: auto auto;
    column-gap: ${theme.space[16]};
    row-gap: ${theme.space[4]};

    ${basicHeaderWithLineStyles}
`;

const SimpleHeaderWithLine = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: ${theme.space[16]};

    ${basicHeaderWithLineStyles}
`;

interface HeaderWithLineProps {
    description?: ReactNode;
    children: ReactNode;
}

export const HeaderWithLine = ({ description, children }: HeaderWithLineProps) => {
    if (description) {
        return (
            <AdvancedHeaderWithLine>
                {children}
                <Text variant="small" color="foreground.muted" style={{ gridRow: 2 }}>
                    {description}
                </Text>
            </AdvancedHeaderWithLine>
        );
    }

    return <SimpleHeaderWithLine>{children}</SimpleHeaderWithLine>;
};
